export default "__VITE_ASSET__jUewC_Fg__"